import { render, staticRenderFns } from "./StationDataWithFallbackStrategyConfig.vue?vue&type=template&id=462647b0"
import script from "./StationDataWithFallbackStrategyConfig.vue?vue&type=script&lang=js"
export * from "./StationDataWithFallbackStrategyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports